var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlainR = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_534_6481)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask0_534_6481",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M24 0H0V24H24V0Z",
  fill: "white"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_534_6481)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24 11.9998C24 11.0398 23.16 10.1999 22.2 10.1999H15.6L9.6 0.599854H7.2L10.2 10.1999H3.6L1.8 7.79985H0L1.2 11.9998L0 16.1998H1.8L3.6 13.7998H10.2L7.2 23.3998H9.6L15.6 13.7998H22.2C23.16 13.7998 24 12.9598 24 11.9998Z",
  fill: "#939CB0",
  fillOpacity: 0.8
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_534_6481"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlainR);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/plain-r.f420494499d1e94a2dc6de137f982144.svg";